// extracted by mini-css-extract-plugin
export var actionButton = "_ii-0";
export var fileInput = "_ii-2";
export var paperclip = "_ii-1";